import {
  deburr as _deburr,
  kebabCase as _kebabCase,
} from 'lodash';

const sanitizeUrl = (text:string): string => _kebabCase(_deburr(text));

export default sanitizeUrl;
